<div *ngIf="isAuthorised">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div [ngClass]="filterType === 'version' ? 'card-highlight' : ''">
    <div class="ia-action-div" *ngIf="currentUserRole === 'Compliance Enterprise' || isSavedPermission">
      <span class="cursor-pointer text-primary ml-2 pull-right" *ngIf="filterType !== 'version'"
        (click)="updateImpactAssessment()"><i class="fa fa-floppy-o text-dark"></i>
        Save</span>
      <span class="cursor-pointer text-primary pull-right ml-2" (click)="downloadReport()"><i
          class="fa fa-download text-dark"></i> Export Report</span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADRT')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = true"
          *ngIf="!impactAssessment.isRecordTime" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = false"
          *ngIf="impactAssessment.isRecordTime" aria-hidden="true"></i>
        Record Time
      </span>
      <span class="cursor-pointer text-primary ml-2 pull-right"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && !impactAssessment.isMerged"
        (click)="openRegulationDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
      <span class="cursor-pointer text-primary ml-2 pull-right"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && impactAssessment.isMerged"
        (click)="openBulkCloseDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADHA')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isHidden = true"
          *ngIf="!impactAssessment.isHidden" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="impactAssessment.isHidden = false"
          *ngIf="impactAssessment.isHidden" aria-hidden="true"></i>
        Hide Assessment
      </span>
      <span class="cursor-pointer text-primary pull-right ml-2"
        *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADIR')" (click)="uploadImportReport()"><i
          class="fa fa-upload text-dark"></i>
        <span> Import Report</span>
        <input id="importReport" (change)="handleImportFileInput($event.target.files)" type="file" multiple
          style="display: none" /><br />
      </span>
      <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADSN')"
        class="cursor-pointer text-primary pull-right ml-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isSendNotification = true"
          *ngIf="!impactAssessment.isSendNotification" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle"
          (click)="impactAssessment.isSendNotification = false" *ngIf="impactAssessment.isSendNotification"
          aria-hidden="true"></i>
        Send Notification
      </span>
      <a (click)="backToCurrentVersion()" *ngIf="filterType === 'version'"
        class="cursor-pointer text-primary pull-right ml-2"><i class="fa fa-undo text-dark"></i>
        Current Version</a>
      <span class="cursor-pointer text-primary pull-right ml-2" (click)="openDialog()"><i
          class="fa fa-history text-dark"></i> Version History</span>
      <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Next')">
        <span class="text-primary float-left" (click)="getSiblings('Next')">Next</span>
      </span>
      <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Previous')">
        <span class="text-primary float-left ml-4" (click)="getSiblings('Previous')">Previous</span>
      </span>
    </div>
    <div class="pl-2 ia-details-div" cdkScrollable (scroll)="scrollHandler($event)">
      <mat-accordion id="SummaryDetails">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Summary Details
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row mr-0 ml-0" *ngIf="impactAssessment.isMerged">
            <span class="ml-4 mr-3"><label class="control-label fw inline-block">Assessment Id </label></span>
            <a>
              <span *ngFor="let item of impactAssessment.merged_Id|stringToArray;" (click)="getUpdatedDbInfo(item)">
                <span
                  [ngClass]="this.impactAssessment.updatedDB_Id == item ?  'parent-id':'link-id d-inline-block'">{{item}}<span
                    class="cursor-pointer ml-1"
                    *ngIf="this.impactAssessment.updatedDB_Id != item && (currentUserRole === 'Compliance Enterprise' || isSavedPermission)"
                    (click)="updateOtherMergedId(item)"><i class="fa fa-times-circle text-white"></i></span></span>
              </span>
            </a>
            <span class="parent-span">
              <label class="control-label fw mr-2 inline-block"> Parent Id </label>
              <span *ngIf="!isParentIdEdit" class="control-label inline-block">{{impactAssessment.updatedDB_Id}}</span>
              <span *ngIf="!isParentIdEdit" class="cursor-pointer text-primary ml-2" (click)="updateParentId()">
                Edit</span>
              <span *ngIf="isParentIdEdit" class="inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="parentId">
                  <option *ngFor="let item of impactAssessment.merged_Id|stringToArray;" value="{{item}}">{{item}}
                  </option>
                </select>
              </span>
              <span *ngIf="isParentIdEdit" class="cursor-pointer text-primary ml-2" (click)="changeParentId()">Confirm
              </span>
            </span>
          </div>
          <div class="row form-group ml-2 mt-1">
            <div class="col-lg-2 col-md-1 mx-width-10pr">
              <label class="control-label fw"> {{ impactAssessment.isMerged? "Id":"Assessment Id" }}</label>
              <div class="control-label" name="ids">{{ this.currentinfoId }}</div>
            </div>
            <div class="col-lg-5 col-md-5 mx-width-40pr">
              <label class="control-label fw">Title</label>
              <div class="control-label div-scroll" name="title">{{ impactAssessment.title }}</div>
            </div>
            <div class="col-lg-2 mx-width-11pr">
              <label class="control-label fw">Type</label>
              <div class="control-label" name="title">{{ impactAssessment.pubType }}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Geography</label>
              <div class="control-label">{{impactAssessment.geography}}</div>
            </div>
            <div class="col-lg-2 mx-width-8pr">
              <label class="control-label fw">Country</label>
              <div class="control-label">{{impactAssessment.country}}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Regulator</label>
              <div class="control-label">{{impactAssessment.regulator}}</div>
            </div>
            <div class="col-lg-1 mx-width-8pr">
              <label class="control-label fw">Date</label>
              <div class="control-label">{{impactAssessment.updatedDB_Date | date: 'dd-MMM-yyyy' }}</div>
            </div>
            <div class="col-lg-1 mx-width-7pr"
              *ngIf="impactAssessment.isRecordTime && commonService.checkPlanTypeAction('IADRT')">
              <label class="control-label fw">Time Spent </label>
              <div class="control-label">{{impactAssessment.timeSpent | minToHour}}</div>
            </div>
          </div>

          <div class="row ml-2">
            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-9 fw">
                  <label class="control-label fw">Description</label>
                </div>
                <div class="col-lg-3" *ngIf="impactAssessment.hyperlink">
                  <a href="{{impactAssessment.hyperlink}}" class=" pull-right" target="_blank">
                    <i class="fa fa-globe"></i>
                    <span class="text-primary cursor-pointer">
                      Source Link</span>
                  </a>
                </div>
                <div class="col-lg-3" *ngIf="!impactAssessment.hyperlink">
                  <span class="pull-right"><i class="fa fa-globe"></i><span> Source Link</span></span>
                </div>
                <div class="col-lg-12 edit_status_changeViewer_group">
                  <div class="edit_status_changeViewer_group"
                    *ngIf="impactAssessment.description && impactAssessment.description.indexOf('<div') < 0">
                    <mat-form-field class="disableText w-100">
                      <textarea matInput [(ngModel)]="impactAssessment.description" class="text-area-css"
                        cdkTextareaAutosize disabled [innerHTML]="impactAssessment.description"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12 desc-text-box"
                    *ngIf="impactAssessment.description && impactAssessment.description.indexOf('<div') >= 0">
                    <div [innerHtml]="impactAssessment.description"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-3 desc-text-box" *ngIf="currentinfoId > 0">
              <app-current-action [userId]="userAccessToken.userId" [templateNo]="impactAssessment.templateNo"
                [itemId]="currentinfoId" [closedType]="'Assess'">
              </app-current-action>
            </div> -->
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="AssessmentDetails">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Assessment Details
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="col-lg-4">
            <label class="control-label fw">Assessor</label>
            <mat-chip-grid #assessorList>
              <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                (removed)="removeAssessor(assessor)">
                {{assessor}}
                <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear
                </mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm mat-autodd-input border-bottom"
                #trigautoAssessor="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
            </mat-chip-grid>
            <mat-autocomplete #assessorAutocomplete="matAutocomplete" (optionSelected)="selectedAssessorEvent($event)">
              <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                {{assessor.name}}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Description Objective
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails.length === 0"
                  [innerHTML]="impactAssessment.assessmentDetails"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails" id="assessmentDetails"
                  [data]="impactAssessment.assessmentDetails" class="f-16"
                  *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>

                <!-- <ckeditor [editor]="Editor" id="assessmentDetails" class="f-16"
                  *ngIf="isADetailPermission && isIADetails1" [(ngModel)]="impactAssessment.assessmentDetails">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Category</label>
              <input type="text" class="form-control form-control-sm"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null" [(ngModel)]="impactAssessment.ruleTopic">
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Actual Status / Stage </label>
              <input type="text" class="form-control form-control-sm"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.assessmentStatus">
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Binding or Non-Binding</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.ruleType">
                <option value="binding">Binding</option>
                <option value="nonBinding">Non-Binding</option>
              </select>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-6">
              <label class="control-label fw">Forseen Application</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="applicationDate"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="applicationDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.applicationDate"
                  name="ApplicationDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="applicationDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #applicationDate></mat-datepicker>
            </div>
            <div class="col-lg-6">
              <label class="control-label fw">Date Last Update</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="lastUpdate" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                  (click)="lastUpdate.open()" class="form-control form-control-sm border-bottom"
                  [(ngModel)]="impactAssessment.lastUpdate" name="LastUpdate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="lastUpdate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #lastUpdate></mat-datepicker>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Compliance Monitoring
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.compAssessment.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.compAssessment">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.compAssessment.length === 0"
                  [innerHTML]="impactAssessment.compAssessment"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.compAssessment" id="compAssessment" class="f-16"
                  [data]="impactAssessment.compAssessment" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>

                <!-- <ckeditor [editor]="Editor" id="compAssessment" class="f-16" *ngIf="isADetailPermission && isIADetails1"
                  [(ngModel)]="impactAssessment.compAssessment">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Dates/Deadlines
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.datesDeadlines.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.datesDeadlines">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.datesDeadlines.length === 0"
                  [innerHTML]="impactAssessment.datesDeadlines"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.datesDeadlines" id="datesDeadlines" class="f-16"
                  [data]="impactAssessment.datesDeadlines" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>

                <!-- <ckeditor [editor]="Editor" id="datesDeadlines" class="f-16" *ngIf="isADetailPermission && isIADetails1"
                  [(ngModel)]="impactAssessment.datesDeadlines">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-6">
              <label class="control-label fw">Links with Any (Gold) Projects </label>
              <input type="text" class="form-control form-control-sm"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.projectReference">
            </div>
            <div class="col-lg-6">
              <label class="control-label fw">Resource Needed</label>
              <input type="text" class="form-control form-control-sm"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.resourceNeeded">
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Business Action
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.businessActions.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.businessActions">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.businessActions.length === 0"
                  [innerHTML]="impactAssessment.businessActions"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.businessActions" id="businessActions" class="f-16"
                  [data]="impactAssessment.businessActions" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>

                <!-- <ckeditor [editor]="Editor" id="businessActions" class="f-16"
                  *ngIf="isADetailPermission && isIADetails1" [(ngModel)]="impactAssessment.businessActions">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">
                <span>Corporate Governance</span>
                <span class="label label-default bg-default p5-20"
                  *ngIf="!impactAssessment.corporateGovernance">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.corporateGovernance === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.corporateGovernance === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.corporateGovernance === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.corporateGovernance === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.corporateGovernance === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.corporateGovernance === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.corporateGovernance">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Sales &
                CS
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.salesCs">None</span>
                <span class="label label-default bg-red p5-20" *ngIf="impactAssessment.salesCs === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.salesCs === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.salesCs === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.salesCs === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.salesCs === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.salesCs === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.salesCs">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Pricing
                & UW & Data
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.pricingUwData">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.pricingUwData === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.pricingUwData === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.pricingUwData === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.pricingUwData === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.pricingUwData === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.pricingUwData === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.pricingUwData">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Finance
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.finance">None</span>
                <span class="label label-default bg-red p5-20" *ngIf="impactAssessment.finance === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.finance === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.finance === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.finance === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.finance === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.finance === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.finance">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">People
                Services
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.peopleServices">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.peopleServices === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.peopleServices === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.peopleServices === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.peopleServices === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.peopleServices === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.peopleServices === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.peopleServices">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Claims
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.claims">None</span>
                <span class="label label-default bg-red p5-20" *ngIf="impactAssessment.claims === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.claims === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.claims === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.claims === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.claims === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.claims === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.claims">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Product
                & Ancillaries
                <span class="label label-default bg-default p5-20"
                  *ngIf="!impactAssessment.productAncillaries">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.productAncillaries === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.productAncillaries === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.productAncillaries === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.productAncillaries === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.productAncillaries === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.productAncillaries === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.productAncillaries">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">EUIGS
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.euigs">None</span>
                <span class="label label-default bg-red p5-20" *ngIf="impactAssessment.euigs === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.euigs === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.euigs === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20" *ngIf="impactAssessment.euigs === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.euigs === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.euigs === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.euigs">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Marketing
                & Communications
                <span class="label label-default bg-default p5-20"
                  *ngIf="!impactAssessment.marketingCommunication">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.marketingCommunication === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.marketingCommunication === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.marketingCommunication === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.marketingCommunication === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.marketingCommunication === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.marketingCommunication === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.marketingCommunication">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-4">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">AECS
                Madrid
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.aecsMadrid">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.aecsMadrid === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.aecsMadrid === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.aecsMadrid === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.aecsMadrid === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.aecsMadrid === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.aecsMadrid === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.aecsMadrid">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
            <div class="col-lg-4">
              <label
                class="control-label input_label_tag d-flex align-items-center w-100 justify-content-between fw">Data
                Protection
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.dataProtection">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.dataProtection === 'High'">High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.dataProtection === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.dataProtection === 'Low'">Low</span>
                <span class="label ml-2 label-default bg-info p5-20"
                  *ngIf="impactAssessment.dataProtection === 'N/A'">N/A</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.dataProtection === 'Impact Not yet'">Impact Not yet</span>
                <span class="label ml-2 label-default bg-primary p5-20"
                  *ngIf="impactAssessment.dataProtection === 'Determined'">Determined</span>
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.dataProtection">
                <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
              </select>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="card" *ngIf="!isAuthorised">
  <div class="crad-body p-2">
    <div>You are not authorised to see this impact assessment.</div>
  </div>
</div>